import React, {useState, useRef, useEffect, useMemo, useCallback, Fragment, useContext} from 'react';

import { VisDiv } from '..';
import { InsertProduct } from './InsertProduct';
import { sortByLocation } from '../../lib/utils'; 
import Swal from "sweetalert2"
import { IoIosAddCircleOutline } from 'react-icons/io';
import useMediaQuery from '../../hooks/useMediaQuery';
import { generatedOfferDoc, generatedOfferWithTotalsDoc } from '../gestioneDatabase/Docs';
import { EditableProduct } from './EditableProduct';

export const EditableProducts = ({ groupProducts, nonConformities, register, item, setItem, commonStyle, isVisible, edit, offer, updatedOffer, updateDataArray, dataArray}) => {
  
    const screenSizeDesktop = useMediaQuery("(min-width: 1540px)")
  
/*     const groupProducts = item?.fieldsIds?.map?.((id)=>{
      const product = !Array.isArray(dataArray) ? undefined : dataArray?.find?.((y)=>y?._id == id)
      return product
  }).filter?.((t)=>t) */
  
    const testFunction = () => {
      console.log("test editable products", "item", item, "dataArray", dataArray, offer)
    }
  
    const addNewLine = (e) => {
      e.stopPropagation();
  
      console.log("ADD LINE", register)
      
    }
    const saveDocs = (data) => {
      //data.stopPropagation();
      
      const offerDocs = data?.map?.((x)=>generatedOfferDoc(x))
      const offerDocsWithTotals = offerDocs?.map?.((x)=>generatedOfferWithTotalsDoc(x))
      const updatedDataWithTotals = [...dataArray, ...offerDocsWithTotals]
      const fieldIds = item?.fieldsIds?.length < 1 ? [] : item?.fieldsIds
      const quantity = [...groupProducts, ...offerDocs]?.map?.((doc)=>Number(doc?.quantity))?.reduce((partialSum, a) => partialSum + a, 0)
      const newItem = {...item, quantity: quantity, fieldsIds: [...fieldIds, ...offerDocs?.map?.((x)=>x?._id)]}
      console.log("save docs", updatedDataWithTotals, newItem)
      
      updateDataArray(updatedDataWithTotals)
      setItem(newItem)
      //(updatedDraggableArray?.filter?.(x=>x)?.sort(sortByOrder))
      const updatedOfferDoc = {...offer, offerFields:[...offer?.offerFields, ...offerDocs ]}
      updatedOffer(updatedOfferDoc)
    }
  
    return (
      <VisDiv rules={[isVisible]}>
        <button  onClick={testFunction}>
          Test Editable Products
        </button>
        <VisDiv rules={[register, false]} className='round-back-button' style={{backgroundColor:"white"}} onClick={(e) => {addNewLine(e)}}> 
          <IoIosAddCircleOutline fontSize={30} />
        </VisDiv>
        <VisDiv style={{zIndex:"1000"}} rules={[register]} >
          <InsertProduct saveFn={saveDocs} commonStyle={commonStyle} data={{register, existingProducts: groupProducts }} />
        </VisDiv>
        <div style={{marginLeft:"35px"}}>
          <EditableProductHeader commonStyle={commonStyle} edit={edit}/>
        </div>
       {
        groupProducts
        ?.sort(sortByLocation)
        ?.map?.((pr, index, array)=>{
          const groupData = {pr, index, item, commonStyle, edit, offer, updatedOffer, updateDataArray, dataArray, screenSizeDesktop, groupProducts:array, register, nonConformities}
          return ( <EditableProduct key={pr?._id} data={groupData}/>)
        })
       }
      </VisDiv>
    )
  }
  export const EditableProductHeader = ({commonStyle, edit, isLabour}) => {
    const screenSizeDesktop = useMediaQuery("(min-width: 1540px)")
    return(
      <div style={{backgroundColor:"#385391", fontSize:"12px", fontWeight:"500", color:"white", display:"flex", }} >
        <VisDiv style={{...commonStyle(edit), textAlign:"center"}}>
          {"COD."}
        </VisDiv>
        <VisDiv style={{...commonStyle(edit), flex:6, justifyContent:"left", minWidth: "185px"}}>
          {"NORMATIVA DI RIFERIMENTO PER L'ADEMPIMENTO AGLI OBBLIGHI DEI PRESIDI ATTREZZATURE E SISTEMI"}
        </VisDiv>
        <VisDiv style={{...commonStyle(edit), flex:6, justifyContent:"left", minWidth: "185px"}}>
          {"DESCRIZIONE"}
        </VisDiv>
        <VisDiv rules={[!edit]} style={{...commonStyle(edit), flex:1.2, minWidth: "85px"}}>
          <span>
           {"UBICAZIONE"}
          </span>
        </VisDiv>
        <VisDiv rules={[!edit]} style={{...commonStyle(edit)}}>
          {"Q.TA’"}
        </VisDiv>
        <VisDiv style={{...commonStyle(edit)}}>
          {"PREZZO CAD."}
        </VisDiv>
        <VisDiv style={{...commonStyle(edit)}}>
          {"SCONTO %"}
        </VisDiv>
        <VisDiv rules={[!edit]} style={{...commonStyle(edit)}}>
          {"PREZZO CAD. SCONTATO"}
        </VisDiv>
        <VisDiv rules={[!edit]} style={{...commonStyle()}}>
          {"TOTALE"}
        </VisDiv>
        <VisDiv rules={[screenSizeDesktop]} style={{...commonStyle(edit), backgroundColor:"red"}}>
          {"PREZZO FORNITORE"}
        </VisDiv>
        <VisDiv  rules={[screenSizeDesktop, !edit]} style={{...commonStyle(), backgroundColor:"red"}}>
          {"TOTALE COSTO"}
        </VisDiv>
        <VisDiv  rules={[screenSizeDesktop, !edit]} style={{...commonStyle(), backgroundColor:"red"}}>
          {"MARGINE"}
        </VisDiv>
        <VisDiv  rules={[screenSizeDesktop, !edit]} style={{...commonStyle(), backgroundColor:"red"}}>
          {"PROFITTO"}
        </VisDiv>
        <VisDiv  rules={[screenSizeDesktop, !edit]} style={{...commonStyle(), backgroundColor:"red"}}>
          {"PROFITTO CAD."}
        </VisDiv>
        <VisDiv  rules={[false, screenSizeDesktop, !edit || isLabour]} style={{...commonStyle(edit), backgroundColor:"red"}}>
          {"MANO D'OPERA"}
        </VisDiv>
    </div>
    )
  }